<template>
<div :style="columnMargin" :class="['swiper-ad',item.columnDefineId == 'CD00000015'?'swiper-ad-height126':'swiper-ad-height96']">
  <van-swipe class="my-swipe" :autoplay="item.autoplay" @change="onChange" indicator-color="white">
    <van-swipe-item @click="doLocationHref(swipeItem)" v-for="(swipeItem,swipeIndex) in item.adList" :key="swipeIndex">
      <video v-if="swipeItem.videoUrl" :class="['swiper-video',item.columnDefineId == 'CD00000015'?'swiper-ad-height126':'swiper-ad-height96']" autoplay muted loop :src="swipeItem.videoUrl" lang="zh-CN" x5-playsinline="true" playsinline="true" webkit-playsinline="true">
        <source id="source_id" :src="swipeItem.videoUrl" type="video/mp4">
      </video>
      <img v-else :class="['swiper-img',item.columnDefineId == 'CD00000015'?'swiper-ad-height126':'swiper-ad-height96']" :src="swipeItem.imgUrl" alt="">
    </van-swipe-item>
    <template #indicator>
      <div v-if="item.adList.length>1" class="custom-indicator">
        <div :class="['custom-indicator-one',{'custom-indicator-cur': indicatorIndex==current}]" v-for="(indicatorItem,indicatorIndex) in item.adList" :key="indicatorIndex"></div>
      </div>
    </template>
  </van-swipe>
</div>
</template>

<script>
export default { 
  name: 'SwiperAd',
  data() {
    return {
      current: 0
    }
  },
  props: {
    item: Object,
  },
  components: {
    
  },
  created() {
  },
  watch: {
  
  },
  computed: {
    columnMargin(){
      var obj = {}
      if(this.item.marginObj){
        obj={
          'margin-top': this.item.marginObj.top,
          'margin-bottom': this.item.marginObj.bottom
        }
      }
			return obj
    }
  },
  methods: {
    onChange(index) {
      this.current = index;
    },
    doLocationHref(obj){
      var self = this
      this.$store.commit('doTrack',{
        href: obj.adHrefUrl,
        columnDefineId: self.item.columnDefineId,
        ccId: obj.ccId,
        adId: obj.adId,
        adName: obj.adName,
        idType: 'adId'
      });
      window.location.href = obj.adHrefUrl
    },
  }
}
</script>

<style scoped>
.swiper-ad{
  width: 344px;
  margin-left: 15.5px;
  margin-top: 10px;
  /* background: red; */
  border-radius: 12px;
  overflow: hidden;
}
.swiper-ad-height126{
  height: 126px;
}
.swiper-ad-height96{
  height: 96px;
}
.my-swipe .van-swipe-item {
  color: #fff;
  font-size: 20px;
  text-align: center;
  /* background-color: #39a9ed; */
}
.swiper-img{
  width: 344px;
}
.swiper-video{
  width: 344px;
  background: #000;
  object-fit: fill;
}
.custom-indicator{
  position: absolute;
  left: 0;
  bottom: 10px;
  width: 100%;
  display: flex;
  justify-content: center
}
.custom-indicator-one{
  width: 10px;
  height: 3px;
  background: rgba(255,255,255,0.27)
}
.custom-indicator-one:first-child{
  border-radius: 1.5px 0 0 1.5px;
}
.custom-indicator-one:last-child{
  border-radius: 0 1.5px 1.5px 0;
}
.custom-indicator-cur{
  width: 11px;
  background: #fff;
  border-radius: 1.5px
}
</style>